var _this = this;

import React, { useEffect } from "react";
import { connect, ReactReduxContext } from 'react-redux';
import { accountHelper } from "../../util";
import * as UTIL from "../../util";
import { TextWCardList } from "../card";
import Heading from '../heading/Heading'; // Redux

import { wishlistDuck } from "../../ducks/wishlist";
import { cartDuck } from "../../ducks/cart";
var wishlistOperations = wishlistDuck.operations;
var cartOperations = cartDuck.operations;
var duckPostCart = cartOperations.postItem;

var AccountFavorites = function AccountFavorites(props) {
  var _props$location = props.location,
      location = _props$location === void 0 ? '' : _props$location,
      _props$noLocation = props.noLocation,
      noLocation = _props$noLocation === void 0 ? '' : _props$noLocation,
      _props$wishlistItems = props.wishlistItems,
      wishlistItems = _props$wishlistItems === void 0 ? {} : _props$wishlistItems,
      _props$handleGetWishl = props.handleGetWishlist,
      handleGetWishlist = _props$handleGetWishl === void 0 ? function () {
    return console.log('Get wishlist');
  } : _props$handleGetWishl,
      _props$addToOrder = props.addToOrder,
      addToOrder = _props$addToOrder === void 0 ? function () {
    return console.log('Add to order');
  } : _props$addToOrder,
      isLoading = props.isLoading;
  var products = wishlistItems.Products;
  var cards = []; // let cards = Array.isArray(products) ? products.map(product => ({fields: UTIL.mapProduct(UTIL.toPascal(product))})) : [];

  if (products && products.length) {
    cards = products.map(function (product) {
      return {
        fields: UTIL.mapProduct(product, location)
      };
    });
  } // if(cards.length) {
  //   cards.map((card) => {
  //     return {
  //       fields: {
  //         ...card.fields,
  //         isFavourite: true
  //       }
  //     }
  //   });
  // }


  var layout = {
    background: 'solid',
    padding: 'medium'
  };
  var title = 'My Favorites';
  useEffect(function () {
    if (!location) {
      handleGetWishlist();
    }
  }, [location]);
  return /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
      level: "2",
      field: {
        value: title
      },
      className: "cb-account__title"
    }), cards.length ? /*#__PURE__*/React.createElement(TextWCardList, {
      noLocation: noLocation,
      addToOrder: addToOrder,
      title: {
        value: ''
      },
      layout: layout,
      cards: cards,
      isLoading: isLoading,
      cardDisplayType: "list",
      totalCardsInRow: "3"
    }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "You have not added any favorites")));
  }.bind(_this));
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$wishlist, _state$location, _state$location$locat, _state$location2, _state$location2$loca;

  return {
    // account: state.account,
    wishlistItems: (_state$wishlist = state.wishlist) === null || _state$wishlist === void 0 ? void 0 : _state$wishlist.wishlistItems,
    isError: state.error.isError,
    err: state.error.err,
    noLocation: !((_state$location = state.location) === null || _state$location === void 0 ? void 0 : (_state$location$locat = _state$location.location) === null || _state$location$locat === void 0 ? void 0 : _state$location$locat.olo_unique_name),
    location: !((_state$location2 = state.location) === null || _state$location2 === void 0 ? void 0 : (_state$location2$loca = _state$location2.location) === null || _state$location2$loca === void 0 ? void 0 : _state$location2$loca.olo_unique_name),
    isLoading: state.cart.isLoading
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleGetWishlist: function handleGetWishlist() {
      return dispatch(wishlistOperations.handleGetWishlist());
    },
    addToOrder: function addToOrder(postData) {
      return dispatch(duckPostCart(postData));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountFavorites);